import { render, staticRenderFns } from "./view.vue?vue&type=template&id=d86bb14c"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d86bb14c')) {
      api.createRecord('d86bb14c', component.options)
    } else {
      api.reload('d86bb14c', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=d86bb14c", function () {
      api.rerender('d86bb14c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/distribution/ratio/view.vue"
export default component.exports